import { render, staticRenderFns } from "./ConfigTabSkills.vue?vue&type=template&id=7a9dfa21"
import script from "./ConfigTabSkills.vue?vue&type=script&lang=js"
export * from "./ConfigTabSkills.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabSkills.vue?vue&type=style&index=0&id=7a9dfa21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports